import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FacebookService {
  private loaded = false;

  constructor() {
    if (!this.loaded) {
      // Cargar el SDK de Facebook
      (window as any).fbAsyncInit = () => {
        FB.init({
          appId: '922734762557319',
          status: true,
          cookie: true,
          autoLogAppEvents: true,
          xfbml: true,
          version: 'v2.7'
        });
      };

      (function (d, s, id) {
        var js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) { return; }
        js = d.createElement(s); js.id = id;
        js.src = "https://connect.facebook.net/en_US/sdk.js";
        fjs.parentNode!.insertBefore(js, fjs);
      }(document, 'script', 'facebook-jssdk'));

      this.loaded = true;
    }
  }

  share(url: string, title: string, imageUrl: string) {
    // Comprobar si FB está definido
    if ((window as any).FB) {
      (window as any).FB.ui({
        method: 'share',
        href: url,
        title: title,
        picture: imageUrl
      }, function (response) { });
    }
  }
}
